// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__uUYU3","logo":"Header_logo__czzBt","userTitle":"Header_userTitle__1VbEq","actions":"Header_actions__3XInE"};